import classNames from "classnames";
import { ReactNode, MouseEventHandler } from "react";

import { ReactComponent as LogoSVG } from "assets/logo.svg";

import MaintenanceBannerController from "./MaintenanceBannerController";

const LoginLayout = ({
  children,
  onClickLogo,
}: {
  children: ReactNode;
  onClickLogo?: MouseEventHandler<HTMLElement>;
}) => {
  return (
    <div className="LoginLayout--wrapper">
      <MaintenanceBannerController isLogin />
      <div className="LoginLayout">
        <figure
          onClick={onClickLogo}
          className={classNames("LoginLayout_logo", {
            Scannable: !!onClickLogo,
          })}
        >
          <LogoSVG />
        </figure>
        <div className="LoginLayout_content">{children}</div>
      </div>
    </div>
  );
};

export default LoginLayout;
